import React from "react";
import { useNavigate } from "react-router-dom";
import { useAuth } from "../hooks/useAuth";
import {
  Home, Users, Calendar, ClipboardList, Settings,
  FileText, Shield, DollarSign, UserPlus, Stethoscope,
} from "lucide-react";

// Map icon string names from roleConfig → actual Lucide components
const ICON_MAP = {
  Home,
  Users,
  Calendar,
  ClipboardList,
  Settings,
  FileText,
  Shield,
  DollarSign,
  UserPlus,
  Stethoscope,
};

export default function BottomNav({ active = "home" }) {
  const navigate = useNavigate();
  const { navItems } = useAuth();

  return (
    <nav
      className="fixed bottom-0 left-1/2 -translate-x-1/2 w-full max-w-lg z-[200] flex justify-around items-end pt-3 pb-5 safe-bottom"
      style={{
        background: "linear-gradient(180deg, rgba(10,15,26,0.95), rgba(10,15,26,1))",
        borderTop: "1px solid rgba(99,179,237,0.1)",
      }}
    >
      {navItems.map((item) => {
        const Icon = ICON_MAP[item.icon] || Home;
        const isAccent = item.accent;
        const isActive = active === item.id;

        if (isAccent) {
          return (
            <button
              key={item.id}
              className="flex flex-col items-center -mt-5"
              onClick={() => navigate(item.path)}
            >
              <div
                className="w-14 h-14 rounded-full flex items-center justify-center"
                style={{
                  background: "linear-gradient(135deg, #3182ce, #2b6cb0)",
                  boxShadow: "0 4px 20px rgba(49,130,206,0.4)",
                  border: "3px solid #0a0f1a",
                }}
              >
                <Icon size={24} color="white" />
              </div>
            </button>
          );
        }

        return (
          <button
            key={item.id}
            className="flex flex-col items-center gap-1"
            onClick={() => navigate(item.path)}
            style={{ color: isActive ? "#63b3ed" : "#4a5568" }}
          >
            <Icon size={22} />
            <span className="text-[10px] font-semibold tracking-wider uppercase">
              {item.label}
            </span>
          </button>
        );
      })}
    </nav>
  );
}